module.exports = "mutation ($data: TaskCreate!) {\n  TaskCreate(data: $data) {\n    id\n  }\n}\n"